import {useEffect, useState} from 'react';
import styles from './admindashboard.module.scss';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {AdminMainLayout} from '../subLayout/adminDashboard';
import {Nav} from '../../components/nav';
import Logo from '../../components/logo/logo';
import PageErrorBoundary from 'components/Error/ErrorContext';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import {TicketAlertsWatcher} from 'pages/aiHelpDesk/TicketAlertsWatcher';

const RAIL_KEY = 'navCollapsed';

const AdminDashboardLayout = () => {
  const [open, setOpen] = useState(false);
  // The sidebar's collapsed rail. Owned here rather than inside the nav so the
  // main column's margin can follow it, and remembered so it survives a
  // reload — an admin who wants the width back should not have to ask twice.
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem(RAIL_KEY) === '1';
    } catch (error) {
      return false;
    }
  });

  const toggleCollapsed = () =>
    setCollapsed(previous => {
      const next = !previous;
      try {
        window.localStorage.setItem(RAIL_KEY, next ? '1' : '0');
      } catch (error) {
        // Private mode / quota — the preference is not worth failing over.
      }
      return next;
    });

  const location = useLocation();
  const navigation = useNavigate();

  useEffect(() => {
    setOpen(false);

    document.documentElement.classList.remove('_fixed');
    document.body.classList.remove('_fixed');
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={styles.layout}>
      <div
        className={`${styles.backdrop} ${open ? styles.show : ''}`}
        onClick={() => {
          setOpen(false);

          document.documentElement.classList.remove('_fixed');
          document.body.classList.remove('_fixed');
        }}></div>

      <header className={styles.header}>
        <div className={`${styles.logo} ${open ? styles.hide : ''}`}>
          <Logo onClick={() => navigation('/admin/dashboard')} />
        </div>

        <div className={styles.hamburgerBtn}>
          <button
            type="button"
            aria-label="navigation button"
            onClick={() => {
              setOpen(!open);

              document.documentElement.classList.toggle('_fixed');
              document.body.classList.toggle('_fixed');
            }}
            className={`hamburger hamburger--spin ${open ? 'is-active' : ''}`}>
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </header>

      <Nav
        isOpen={open}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
      />

      {/* App-wide background poller: watches the support queue and drives the
          Customer Support badge + beep. No-ops for admins without access. */}
      <TicketAlertsWatcher />

      <main
        id="daba-main"
        className={`${styles.main} ${collapsed ? styles.mainRailed : ''}`}>
        <ErrorBoundary>
          <PageErrorBoundary>
            <AdminMainLayout>
              <Outlet />
            </AdminMainLayout>
          </PageErrorBoundary>
        </ErrorBoundary>
      </main>
    </div>
  );
};

export {AdminDashboardLayout};
